"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNotifications = useNotifications;
var _auth = require("@ori/auth");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _headers = require("../constants/headers");
var _logger = require("../logger");
var _isOnBehalf = require("../utils/isOnBehalf");
var _removeUtmParams = require("../utils/removeUtmParams");
const isDevelopment = process.env.NODE_ENV === 'development';
const logger = _logger.mainLogger.createChild('useNotifications');
function useMarkAllAsSeen() {
  const client = (0, _globalApiClientReact.useApiClient)();
  const {
    token
  } = (0, _auth.useToken)();
  return async customerId => {
    const onBehalf = (0, _isOnBehalf.isOnBehalf)(token);
    if (!isDevelopment && onBehalf) {
      return true;
    }
    return (0, _globalApiClientReact.createCustomerInAppNotificationsSeen)(client, customerId, {
      [_headers.HEADER_KEY_X_CLIENT_APPLICATION]: _headers.HEADER_VALUE_X_CLIENT_APPLICATION
    });
  };
}

/** This is a type that represents data for a notification  */

/**
 * Loads all notifications and marks them as read
 */
function useNotifications(shouldLoad) {
  const {
    customerId
  } = (0, _auth.useToken)();
  const markAllAsSeen = useMarkAllAsSeen();
  const client = (0, _globalApiClientReact.useApiClient)();
  return (0, _fetching.useSWR)(shouldLoad ? [customerId, 'all-notifications'] : null, async ([forCustomerId]) => {
    const {
      data
    } = await (0, _globalApiClientReact.getCustomerInAppNotifications)(client, forCustomerId, {
      [_headers.HEADER_KEY_X_CLIENT_APPLICATION]: _headers.HEADER_VALUE_X_CLIENT_APPLICATION
    }, {
      take: 99,
      sortType: _globalApiClientReact.GetCustomerInAppNotificationsSortType.Descending
    });
    const notifications = data.notifications.filter(n => !n.isDeleted).map(n => ({
      ...n,
      link: (0, _removeUtmParams.removeUtmParams)(n.link ?? '')
    }));
    const newNotifications = notifications.filter(n => !n.isSeen);
    const earlierNotifications = notifications.filter(n => n.isSeen);
    const result = {
      newNotificationsCount: newNotifications.length + earlierNotifications.length,
      notifications: {
        new: newNotifications,
        earlier: earlierNotifications
      }
    };

    // Mark all as seen when user opens the menu and recieves items, however waiting for it to finish marking it as seen does not seem very efficient in terms of UX
    if (result.notifications.new.length > 0) {
      void markAllAsSeen(forCustomerId).catch(error => {
        logger.error(new Error('Failed to mark all notifications as seen', {
          cause: error
        }));
      });
    }
    return result;
  }, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    suspense: false
  });
}
